import BreadCrumb from "Components/Common/BreadCrumb";
import React, { useEffect, useState } from "react";
import { Card } from "reactstrap";
import filterIcon from "../../../../assets/images/filter-icon.png";
import searchIcon from "../../../../assets/images/search-normal.png";

import "../ReviewAnalysis/ReviewAnalysis.scss";
import ReviewAnalysisCard from "../components/ReviewAnalysisCard";
import axios from "axios";
const ReviewAnalysis = (props: any) => {
  const [showFilters, setShowFilters] = useState(false);
  const [totalPages, setTotalPages] = useState<number>(1);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [reviewsAnalysis, setReviewsAnalysis] = useState<any>();
  const [searchTerm, setSearchTerm] = useState("");
  const [counts, setCounts] = useState<any>();
    const [itemsPerPage, setItemsPerPage] = useState(20);
  const [firstInput, setFirstInput] = useState("");
  const [secondInput, setSecondInput] = useState("");
  const [thirdInput, setThirdInput] = useState("");
  const [filterType, setFilterType] = useState("");
  const [keywordType, setKeywordType] = useState("");
  const [selectedRows, setSelectedRows] = useState<string[]>([]);
  const [selectAll, setSelectAll] = useState(false);


  const toggleFilters = () => {
    setShowFilters((prev) => !prev);
  };

  useEffect(() => {
        const handler = setTimeout(() => {
          onGetReviewsAnalysis(currentPage);
        }, 500);
    
        return () => {
          clearTimeout(handler);
        };
        // eslint-disable-next-line
      }, [searchTerm, currentPage]);
  
  useEffect(() => {
    onGetReviewsAnalysis(currentPage);
  }, [currentPage,itemsPerPage]);

  const handleItemsPerPageChange = (e:any) => {
    setItemsPerPage(Number(e.target.value));
    setCurrentPage(1); // Reset to page 1 when count changes
  };

  const onGetReviewsAnalysis = async (page: number) => {
    try {
      const response = await axios.get(
        `api/v1/reviews/analysis?page=${page}&count=${itemsPerPage}&keyword=${searchTerm}`
      );
      if (response?.data) {
        setReviewsAnalysis(response.data.data);
        setCounts(response.data.counts);
        setTotalPages(
          Math.ceil(response.data.totalCount.totalDocuments / itemsPerPage)
        );
      }
    } catch (err: any) {
    } finally {
    }
  };

  const onGetReviewsAnalysisWithStatus = async (
    page: number,
    filterType: string
  ) => {
    try {
      let keyword = firstInput.trim() !== "" ? firstInput : secondInput;
      let finalKeywordType = "";
      if (!filterType && firstInput.trim() !== "") {
        finalKeywordType = "productId";
      } else if (!filterType && secondInput.trim() !== "") {
        finalKeywordType = "productName";
      } else if (!filterType && thirdInput.trim() !== "") {
        finalKeywordType = "sellerSKU";
      } else {
        keyword = "";
      }

      const response = await axios.get(
        `api/v1/reviews/analysis?page=${page}&count=${itemsPerPage}&keyword=${keyword}&filterType=${filterType}&keywordType=${finalKeywordType}`
      );

      if (response?.data) {
        setReviewsAnalysis(response.data.data);
        setCounts(response.data.counts);
        setTotalPages(
          Math.ceil(response.data.totalCount.totalDocuments / itemsPerPage)
        );
      }
    } catch (err: any) {
      console.error(err);
    }
  };

  const handleFilterTypeClick = (filterType: string) => {
    setFirstInput("");
    setSecondInput("");
    setFilterType(filterType);
    onGetReviewsAnalysisWithStatus(currentPage, filterType);
  };

  const reviewRecivedFilters = [
    { label: "All", value: "" },
    { label: "No Review", value: "noReviews" },
    { label: "1-4 Reviews", value: "oneToFourReviews" },
    { label: "More then 4 Review", value: "moreThanFourReviews" },
  ];

  const ratingScoreFilters = [
    { label: "All", value: "" },
    {
      label: "Negative (less than 3 starts)",
      value: "negativeLessThanThreeStars",
    },
    {
      label: "Positive (more than 3 starts)",
      value: "positiveMoreThanThreeStars",
    },
  ];

  useEffect(() => {
    if (keywordType.length > 3) {
      onGetReviewsAnalysisWithStatus(currentPage, "");
    }
  }, [keywordType]);

    const handlePageChange = (page: number) => {
      setCurrentPage(page);
    };

  return (
    <React.Fragment>
      <div className="page-content reviewAnalysisPage">
        <BreadCrumb
          title="Rating & Review Management"
          pageTitle="Orders"
          pageTitleRoute="/order-review"
        />

        <Card className="mainRatingCard navigationDv">
          <div className="serchNavigationDv">
            <div className="serchDv">
              <i className="bx bx-search"></i>
              <input
                type="text"
                placeholder="Search"
                data-testing-id="serachInput_reviewAnalysis"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </div>
            <div className="paginationDv">
              <nav aria-label="Page navigation example">
                <ul className="pagination detailPagepagi">
                  <select value={itemsPerPage} style={{margin:'5px'}} onChange={handleItemsPerPageChange}>
          <option value={20}>20</option>
          <option value={50}>50</option>
          <option value={80}>80</option>
          <option value={100}>100</option>
        </select>
                  <li
                    className={`page-item ${
                      currentPage === 1 ? "disabled" : ""
                    }`}
                  >
                    <button
                      style={{
                        height: "26px",
                        display: "flex",
                        alignItems: "center",
                        border: "none",
                      }}
                      className="page-link"
                      onClick={() =>
                        setCurrentPage((prev) => Math.max(prev - 1, 1))
                      }
                    >
                      <i
                        style={{ height: "11px" }}
                        className="bx bxs-left-arrow"
                      ></i>
                    </button>
                  </li>
                    {Array.from({ length: Math.min(totalPages, 5) }, (_, i) => {
  let startPage = 1;

  if (totalPages <= 5) {
    startPage = 1;
  } else if (currentPage <= 3) {
    startPage = 1;
  } else if (currentPage >= totalPages - 2) {
    startPage = totalPages - 4;
  } else {
    startPage = currentPage - 2;
  }

  return startPage + i;
                  }).map((page) => (
                    <div>
                      <li
                        className={`page-item ${
                          currentPage === page ? "active" : ""
                        }`}
                        key={page}
                      >
                        <button
                          style={{ height: "26px" }}
                          className="page-link orderPg"
                          onClick={() => setCurrentPage(page)}
                        >
                          {page}
                        </button>
                      </li>
                    </div>
                  ))}
                  <li
                    className={`page-item ${
                      currentPage === totalPages ? "disabled" : ""
                    }`}
                  >
                    <button
                      className="page-link orderPg"
                      style={{
                        height: "26px !important",
                        display: "flex",
                        alignItems: "center",
                        border: "none",
                      }}
                      onClick={() =>
                        setCurrentPage((prev) => Math.min(prev + 1, totalPages))
                      }
                    >
                      <i
                        className="bx bxs-right-arrow"
                        style={{ width: "6px", height: "11px" }}
                      ></i>
                    </button>
                  </li>

                   <select
    value={currentPage}
    onChange={(e) => handlePageChange(Number(e.target.value))}
    style={{
      margin: "0 10px",
      padding: "2px 6px",
      borderRadius: "4px",
      border: "1px solid #ccc",
      fontSize: "13px",
    }}
  >
    {Array.from({ length: totalPages }, (_, i) => i + 1).map((pageNum) => (
      <option key={pageNum} value={pageNum}>
        Page {pageNum}
      </option>
    ))}
  </select>
                </ul>
              </nav>
            </div>
          </div>

          <table className="AnalysisTable mobile-hide">
            <thead>
              <tr>
                <th className="firstChildTH">
                  <div className="d-flex align-items-center gap-2">
                    <input
                            type="checkbox"
                            checked={selectedRows.length === (reviewsAnalysis?.length || 0)}
                            onChange={(e) => {
                              const checked = e.target.checked;
                              setSelectAll(checked);
                              if (checked) {
                                const allIds = reviewsAnalysis.map((item: any) => item?.product?._id);
                                setSelectedRows(allIds);
                              } else {
                                setSelectedRows([]);
                              }
                            }}
                          />
                    <h6>Product</h6>
                  </div>
                </th>
                <th className="SecondChildTH">
                  <h6>Reviews </h6>
                </th>
                <th className="ThirdChildTH">
                  <h6>Rating</h6>
                </th>
                <th className="FourthChildTH">
                  <h6>Rating Score</h6>
                </th>
                <th className="LastChildTH">
                  <div className="d-flex gap-5 justify-content-end align-items-center">
                    <h6>Quality Reviews</h6>
                    <div
                      onClick={toggleFilters}
                      className="d-flex justify-content-end"
                      data-testing-id="filter_Reviewanalysis"
                    >
                      <div className="filter">
                        <img
                          src={filterIcon}
                          style={{
                            width: "10px",
                            height: "10px",
                            marginRight: "5px",
                          }}
                          alt=""
                        />
                        <h4 className="text-secondary mb-0 mt-1"> Filter </h4>
                      </div>
                    </div>
                  </div>
                </th>
              </tr>
            </thead>
          </table>

          {showFilters && (
            <div className="chipTodayContainer-main different-chip-main">
              <div className="chipTodayContainer">
                <div className="d-flex gap-3 align-items-center">
                  <div>
                    <a className="m-0">Reviews Received</a>
                  </div>
                  <div className="d-flex gap-2 align-items-center">
                    {reviewRecivedFilters.map((reviewRecived) => (
                      <p
                        key={reviewRecived.value}
                        className={`chipDv ${
                          filterType === reviewRecived.value ? "active" : ""
                        }`}
                        tabIndex={0}
                        data-testing-id={`selectFilters_reviewAnalysis_${reviewRecived.value}`}
                        onClick={() =>
                          handleFilterTypeClick(reviewRecived.value)
                        }
                        onBlur={() => setFilterType("")}
                      >
                        {reviewRecived.label}
                      </p>
                    ))}
                  </div>
                </div>
                <div className="d-flex gap-3 align-items-center">
                  <div>
                    <a className="m-0">Rating Score</a>
                  </div>
                  <div className="d-flex gap-2 align-items-center">
                    {ratingScoreFilters.map((ratingScore) => (
                      <p
                        key={ratingScore.value}
                        className={`chipDv ${
                          filterType === ratingScore.value ? "active" : ""
                        }`}
                        tabIndex={0}
                        data-testing-id={`selectFilters_reviewAnalysis_${ratingScore.value}`}
                        onClick={() => handleFilterTypeClick(ratingScore.value)}
                        onBlur={() => setFilterType("")}
                      >
                        {ratingScore.label}
                      </p>
                    ))}
                  </div>
                </div>
                {/* <div className="d-flex gap-3 align-items-center">
                  <div>
                    <a className="m-0">Status</a>
                  </div>
                  <div className="d-flex gap-2 align-items-center">
                    <p
                      className="chipDv"
                      data-testing-id="selectFilters_EcommercerOrder"
                    >
                      All
                    </p>
                    <p
                      className="chipDv"
                      data-testing-id="selectFilters_EcommercerOrder"
                    >
                      Warning
                    </p>
                    <p
                      className="chipDv"
                      data-testing-id="selectFilters_EcommercerOrder"
                    >
                      Healthy
                    </p>
                    <p
                      className="chipDv"
                      data-testing-id="selectFilters_EcommercerOrder"
                    >
                      Mo Review
                    </p>
                  </div>
                </div> */}
              </div>
              <div className="input-main">
                <div className="input">
                  <input
                    type="text"
                    placeholder="Product ID"
                    data-testing-id="productIDInput_EcommercerOrder"
                    value={firstInput}
                    onChange={(e) => {
                      setFirstInput(e.target.value);
                      setKeywordType("productId");
                    }}
                    onFocus={() => {
                      setFirstInput("");
                      setKeywordType("");
                    }}
                  />
                  <img src={searchIcon} alt="" />
                </div>
                <div className="input">
                  <input
                    type="text"
                    placeholder="Item Name"
                    data-testing-id="itemNameInput_EcommercerOrder"
                    value={secondInput}
                    onChange={(e) => {
                      setSecondInput(e.target.value);
                      setKeywordType("productName");
                    }}
                    onFocus={() => {
                      setSecondInput("");
                      setKeywordType("");
                    }}
                  />
                  <img src={searchIcon} alt="" />
                </div>
                <div className="input">
                  <input
                    type="text"
                    placeholder="Seller SKU"
                    data-testing-id="sellerSKUInput_EcommercerOrder"
                    value={thirdInput}
                    onChange={(e) => {
                      setThirdInput(e.target.value);
                      setKeywordType("sellerSKU");
                    }}
                    onFocus={() => {
                      setThirdInput("");
                      setKeywordType("");
                    }}
                  />
                  <img src={searchIcon} alt="" />
                </div>
              </div>
            </div>
          )}
        </Card>
        <div className="cardMarResAnal">
        <>
          {reviewsAnalysis && reviewsAnalysis.length > 0 ? (
            reviewsAnalysis.map((reviewsAnalysis: any, index: any) => (
              <ReviewAnalysisCard
                key={reviewsAnalysis._id}
                reviewsAnalysis={reviewsAnalysis}
                index={index}
                setReviewsAnalysis={setReviewsAnalysis}
                setTotalPages={setTotalPages}
                selectedRows={selectedRows}
                setSelectedRows={setSelectedRows}
              />
            ))
          ) : (
            <h2>No Data Found!</h2>
          )}
        </>
        </div>
      </div>
    </React.Fragment>
  );
};

export default ReviewAnalysis;
